import { IPublishedOffer, IResidentOfferContent } from '../../../models';

export const offerConverter = {
  fromDto: (response: IResidentOfferContent): IPublishedOffer => {
    return {
      id: response.id,
      title: response.title,
      text: response.text,
      href: response.href,
      linkText: response.linkText,
      titleImageId: response.titleImageId,
      publishedAt: response.publishedAt,
    };
  },
};
